import { useFirebaseAuth } from '@smart-maps/firebase';
import classnames from 'classnames';
import get from 'lodash.get';
import React, { useCallback, useRef, useState } from 'react';
import { MdCloudUpload as UploadIcon } from 'react-icons/md';
import { createUseStyles } from 'react-jss';
import { useDispatch } from 'react-redux';

import { importTodos } from '../../../redux/actions';

const useStyles = createUseStyles({
  button: {
    borderRadius: 4,
    composes: [
      'p12',
      'my6',
      'fs14',
      'flex-columns',
      'flex-center',
      'items-center',
      'is-full-width',
    ],
    cursor: 'pointer',
    maxHeight: 46,
    transition: 'color 0.3s, background 0.3s',
  },
  input: {
    composes: ['flex-columns', 'flex-center', 'items-center'],
    cursor: 'pointer',
  },
  label: {
    composes: ['use-pointer', 'mr12'],
  },
});

const ImportButtonComponent = React.memo(() => {
  const upload = useRef();
  const classes = useStyles();
  const dispatch = useDispatch();
  const { user } = useFirebaseAuth();

  const [loading, setLoading] = useState(false);

  const errorHandler = useCallback(err => {
    setLoading(false);
    // eslint-disable-next-line
    console.log('err', err);
  }, []);

  const loadStartHandler = useCallback(() => {
    setLoading(true);
  }, []);

  const onAbort = useCallback(() => {
    setLoading(false);
  }, []);

  const onLoad = useCallback(
    ({ target }) => {
      const json = get(target, 'result', null);
      const data = JSON.parse(json);
      if (data) {
        dispatch(importTodos(data, user));
        setLoading(false);
      } else {
        errorHandler(new Error('Unable to import'));
      }
    },
    [user, dispatch, errorHandler]
  );

  const uploadHandler = useCallback(
    evt => {
      evt.preventDefault();
      try {
        const [file] = evt.target.files;
        const reader = new FileReader();
        reader.onload = onLoad;
        reader.onabort = onAbort;
        reader.onerror = errorHandler;
        reader.onloadstart = loadStartHandler;
        reader.readAsText(file);
      } catch (error) {
        errorHandler(error);
      }
    },
    [errorHandler, loadStartHandler, onAbort, onLoad]
  );

  return (
    <div
      className={classnames(
        classes.button,
        { loading },
        'smart-maps-button-gold'
      )}
      role="button"
      tabIndex={-1}>
      <label className={classes.input} htmlFor="uploader">
        <span className={classes.label}>Importer</span>
        <UploadIcon size={22} />
      </label>
      <input
        ref={upload}
        accept=".json,application/json"
        className="is-hidden"
        id="uploader"
        name="uploader"
        type="file"
        onChange={uploadHandler}
      />
    </div>
  );
});

ImportButtonComponent.displayName = 'ImportButtonComponent';

export default ImportButtonComponent;
